import React from 'react'

import OurTeam from './OurTeam'

import ClientsList from './ClientsList'

import './styles/AboutUs.scss'
import Logo from "../images/Logo--menu.svg";

// Импорты иконок
import {
    Database,
    LineChart,
    Trophy,
    BookOpen,
    Settings,
    Cpu,
    ShieldCheck,
    Clock,
    Users,
    Globe
} from 'lucide-react'

// Соответствие ключа и компонентной иконки
const iconMap = {
    data: <Database className="feature-icon" />,
    graph: <LineChart className="feature-icon" />,
    trophy: <Trophy className="feature-icon" />,
    book: <BookOpen className="feature-icon" />,
    gear: <Settings className="feature-icon" />,
    chip: <Cpu className="feature-icon" />,
    shield: <ShieldCheck className="feature-icon" />,
    clock: <Clock className="feature-icon" />,
    people: <Users className="feature-icon" />,
    independence: <Globe className="feature-icon" />
}

const features = [
    {
        title: "Управление на основе данных",
        text: "Мы помогаем компаниям перейти от решений «по интуиции» к управлению, основанному на реальных данных.",
        icon: "data"
    },
    {
        title: "Оценка динамики процессов",
        text: "Мы предоставляем понятные и наглядные инструменты для анализа результатов автоматизации.",
        icon: "graph"
    },
    {
        title: "Повышение конкурентоспособности",
        text: "Внедряем передовые IT-инструменты, ранее доступные лишь крупным корпорациям.",
        icon: "trophy"
    },
    {
        title: "Повышение IT-грамотности",
        text: "Обучаем сотрудников, включая топ-менеджеров, современным IT-подходам.",
        icon: "book"
    },
    {
        title: "Самостоятельное развитие системы",
        text: "После проекта клиент может развивать и поддерживать систему самостоятельно.",
        icon: "gear"
    },
    {
        title: "Доступность технологий",
        text: "Теперь IT-решения доступны не только гигантам, но и вашему бизнесу.",
        icon: "chip"
    },
    {
        title: "Гарантия завершенности",
        text: "Мы сопровождаем клиента до конца, поддерживая проект на всех этапах.",
        icon: "shield"
    },
    {
        title: "Ценность времени",
        text: "Избавляем сотрудников от рутины — даем время на важное.",
        icon: "clock"
    },
    {
        title: "Люди и технологии вместе",
        text: "Автоматизация не ради отчета, а для удобства, прозрачности и смысла.",
        icon: "people"
    },
    {
        title: "Цифровая независимость",
        text: "Мы продвигаем решения, соответствующие задачам, а не моде.",
        icon: "independence"
    }
]


const splitArray = (arr) => {
    const mid = Math.ceil(arr.length / 2);
    return [arr.slice(0, mid), arr.slice(mid)];
};

const [column1, column2] = splitArray(features);


function AboutUs() {
    return (
        <div className="AboutUs-container">
            <div className="AboutUs-container__text">
                <h1 className="align-center tp-black">
                    <img src={Logo} alt=""/> кто мы такие
                </h1>
                <p className="main-text aboutUs-container__main-text">
                    Мы — международная команда IT-экспертов, лидеры корпоративной автоматизации в Республике Казахстан, проводники новейших технологий для бизнеса.

                    <br/><br/>

                    Наши клиенты — крупнейшие коммерческие компании Казахстана и СНГ. Мы помогаем <span style={{textDecoration: 'underline'}}> холдингам, недропользователям, финансовым, производственным и торговым компаниям</span>  вести успешный бизнес с помощью цифровизации.
                </p>

                <div className="AboutUs-container__clients">
                    <ClientsList/>
                </div>

                <div className={'AboutUs-container__mission'}>
                    <h2>Наша миссия</h2>
                    <p className={'AboutUs-container__text--mission'}>
                        Мы учим компьютеры помогать людям: повышаем прозрачность, управляемость, конкурентоспособность бизнеса, избавляем сотрудников от рутины, освобождая время для жизни.

                        <br/><br/>

                        Через развитие IT-сектора и импортозамещение вносим свой вклад в рост благосостояния страны <span style={{textDecoration: 'underline'}}> и «поддерживаем огонь» инженерной школы в Казахстане.</span>
                    </p>
                    <br/>

                    <div className="aboutUs-container__features">
                        <div className="features-column">
                            {column1.map((item, index) => (
                                <div className="feature-item" key={`feature-${index}`}>
                                    {iconMap[item.icon]}
                                    <div className="feature-text">
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="features-column">
                            {column2.map((item, index) => (
                                <div className="feature-item" key={`feature-${index + column1.length}`}>
                                    {iconMap[item.icon]}
                                    <div className="feature-text">
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/*<div>*/}

                {/*    <h2 className={'aboutUs-header-image'}><img src={Logo} alt=""/> чем хорош наш подход?</h2>*/}
                {/*</div>*/}

                <div className={'AboutUs-container__quote'}>
                    «Управление на основе данных – это не просто анализ показателей. Это стратегия цифровой
                    трансформации бизнеса, позволяющая компаниям быть более эффективными, адаптивными и
                    конкурентоспособными.»
                </div>
            </div>

            <hr/>
            <OurTeam/>
        </div>
    );
}

export default AboutUs
